// extracted by mini-css-extract-plugin
export default {"dateHistoryContainer":"AnamneseHistory_dateHistoryContainer__lV0rU"};